/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaTextarea from 'DesignSystem/TysiaTextarea/index'
import TysiaTextareaContent from 'DesignSystem/TysiaTextarea/TysiaTextareaContent/index'
import TysiaTextareaField from 'DesignSystem/TysiaTextarea/TysiaTextareaField/index'
import TysiaTextareaLabel from 'DesignSystem/TysiaTextarea/TysiaTextareaLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Notes/Content",
  onChange,
  isInvalid,
  onSubmit
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let treatmentNotesValueData = fromData.useDataValue({ viewPath,
context: 'treatment_notes',
})
let treatmentNotesIsValidData = fromData.useDataIsValid({ viewPath,
context: 'treatment_notes',
validate: fromValidate.textInput,
})
let treatmentNotesChangeData = fromData.useDataChange({ viewPath,
context: 'treatment_notes',
})
let treatmentNotesSubmitData = fromData.useDataSubmit({ viewPath,
context: 'treatment_notes',
})
  return (<React.Fragment
>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
 marginTop={dtSpaceXxs}
>
{childProps => (
<React.Fragment>
<TysiaTextareaLabel
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaLabel`}
 text="Notes"
/>
<TysiaTextareaContent
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaContent`}
 height={224}
>
{childProps => (
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
 data="treatment_notes"
 validate="/Data/validate.js textInput"
 onChange={treatmentNotesChangeData}
 value={treatmentNotesValueData}
 isInvalid={!treatmentNotesIsValidData}
 onBlur={treatmentNotesSubmitData}
/>
)}
</TysiaTextareaContent>
</React.Fragment>
)}
</TysiaTextarea>
{children}
</React.Fragment>)
}